// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","promoTab":"_3lgyajIY0PMVzaf2","promoText":"_36bskdN-_GhIphN-","dropdown":"_2600reEDxyKVjQFk"};